import{EventEmitter as e}from"events";class t{emitter=new e;emit(e,...t){this.emitter.emit(e,...t)}on(e,t){this.emitter.on(e,t)}removeListener(e,t){this.emitter.removeListener(e,t)}}export{t as default};
